import Api from './api';
import DeliveryOccasion from 'models/delivery-occasion';
import { JsonApiResponse, toJsonApiResponse } from 'utils/json-api';

export default class DeliveryOccasionsService {
    static async fetchDeliveryOccasions(): Promise<JsonApiResponse<DeliveryOccasion[]>> {
        let response = await Api.get('delivery-occasions');
        return await toJsonApiResponse<DeliveryOccasion[]>(response);
    }
}